export default "__VITE_ASSET__3dffca1f__"